import { useAppSelector } from "../../store";
import useSWRFetcher from "../fetcher";
import {
  Shipment,
  ShipmentsResponse,
} from "../../../../reducers/uploadedBoard";
import useSWR from "swr";
import settings from "../../../../constants/settings";

export default function useShipmentsFromContext(boardId: string) {
  const shipments = useAppSelector(
    (state) => state.uploadedBoard.boards[boardId]?.shipments,
  );

  if (shipments === undefined || Object.keys(shipments).length === 0) {
    return null;
  }

  return Object.values(shipments).sort((l, r) => {
    return l.ship_date < r.ship_date ? -1 : l.ship_date > r.ship_date ? 1 : 0;
  });
}

export function useShipments(boardId?: string | null) {
  const fetcher = useSWRFetcher<ShipmentsResponse>(undefined);

  const { data } = useSWR<ShipmentsResponse>(
    boardId ? `${settings.api_url}/boards/${boardId}/shipments` : null,
    fetcher,
  );

  return { shipments: data?.shipments || null };
}

export function useShipment(boardId: string, shipmentId: string) {
  const fetcher = useSWRFetcher<Shipment>(undefined);

  const { data } = useSWR<Shipment>(
    boardId === null
      ? null
      : `${settings.api_url}/boards/${boardId}/shipments/${shipmentId}`,
    fetcher,
  );

  return { shipment: data || null };
}
